module.exports = __webpack_public_path__ + "static/img/banner.93b8cc07.png";